import React from 'react';
import { Grid, Typography, IconButton, Accordion, AccordionSummary, AccordionDetails, Divider, Box, Card, CardContent } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ChevronRight, ExpandMore, Clear } from '@material-ui/icons';
import clsx from 'clsx';
import Block from '../QuickSummary/Block';
import { useStyles as quickSummaryStyles } from '../QuickSummary/Styles';

const QuickSummarySection = ({
  classes,
  expanded,
  setExpanded,
  quickSummaryStatuses,
  quickSummaryFilter,
  handleClearQuickSummary,
  handleQuickStatus,
  cmoSite,
  deliverableType,
  loading,
}) => {
  const quickSummaryClasses = quickSummaryStyles();
  
  // Create 5 skeleton cards for loading state
  const renderSkeletonCards = () => {
    return Array.from({ length: 5 }).map((_, index) => (
      <Grid key={`skeleton-${index}`} item style={{ flex: '1 1 0', minWidth: 0, height: '120px' }}>
        <Card
          className={quickSummaryClasses.cardStyle}
          style={{ pointerEvents: 'none' }}
        >
          <CardContent className={quickSummaryClasses.cardContent}>
            <Grid container style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                <Skeleton
                  variant="text"
                  width={60}
                  height={60}
                  animation="wave"
                  style={{ borderRadius: '4px' }}
                />
              </Grid>
              <Grid item style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                <Skeleton
                  variant="text"
                  width="80%"
                  height={20}
                  animation="wave"
                  style={{ borderRadius: '4px' }}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    ));
  };

  return (
    <>
      <Divider style={{ marginTop: '1rem' }} />
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        style={{ boxShadow: 'none', margin: 0 }}
      >
        <AccordionSummary 
          className={classes.accordionSummary}
        >
          <Grid container style={{ justifyContent: 'space-between' }}>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  style={{ marginRight: '8px', padding: '4px' }}
                  onClick={() => setExpanded(!expanded)}
                  size="small"
                >
                  {expanded ? <ExpandMore /> : <ChevronRight />}
                </IconButton>
                <Typography
                  variant="body2"
                  // Match PO Dashboard "Quick Summary" heading exactly:
                  // body2 (0.875rem/14px) + fontWeight 600 — no explicit fontSize.
                  // Previously PD used fontSize:'1rem' which made this heading
                  // visibly larger than every other dashboard.
                  style={{ paddingBottom: 'inherit', fontWeight: 600 }}
                >
                  Quick Summary:
                </Typography>
              </div>
            </Grid>
            {quickSummaryFilter && (
              <Grid item>
                <Typography
                  variant="caption"
                  color="primary"
                  onClick={handleClearQuickSummary}
                  className={clsx(
                    classes.dpFlx,
                    classes.algnCntr,
                    classes.pointer,
                    classes.onHvrUndrline
                  )}
                >
                  Clear Quick Summary
                  <Clear color="primary" style={{ fontSize: 15 }} />
                </Typography>
              </Grid>
            )}
          </Grid>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0.5rem' }}>
          {loading ? (
            <Grid
              container
              spacing={1}
              wrap="nowrap"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                minHeight: '120px',
                overflow: 'hidden',
              }}
            >
              {renderSkeletonCards()}
            </Grid>
          ) : (
            <Grid
              container
              spacing={1}
              wrap="nowrap"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                minHeight: '120px',
                overflow: 'hidden',
              }}
            >
              {quickSummaryStatuses
                .map((statusItem, index) => (
                  <Grid key={index} item style={{ flex: '1 1 0', minWidth: 0, height: '120px' }}>
                    <Block
                      data={statusItem}
                      selectedValue={quickSummaryFilter}
                      handleQuickStatus={handleQuickStatus}
                      loading={false}
                      cmoSite={cmoSite}
                      deliverableType={deliverableType}
                    />
                  </Grid>
                ))}
            </Grid>
          )}
        </AccordionDetails>
      </Accordion>
      <Divider />
    </>
  );
};

export default QuickSummarySection;

